import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const VISITOR_KEY = "evosoft_vid";

function getVisitorId() {
  try {
    let vid = localStorage.getItem(VISITOR_KEY);
    if (!vid) {
      vid = (crypto.randomUUID && crypto.randomUUID()) || `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(VISITOR_KEY, vid);
    }
    return vid;
  } catch {
    return "";
  }
}

/**
 * Fires an anonymous page-view event on every route change.
 * Skips paths in `skip` and also skips whenever a user is authenticated,
 * so admin/technician logins don't inflate the marketing analytics.
 */
export default function AnalyticsTracker({ skip = [] }) {
  const location = useLocation();
  const { user, loading } = useAuth();
  useEffect(() => {
    if (loading) return; // wait until we know auth state
    if (user) return; // authenticated users are NOT tracked
    const path = location.pathname || "/";
    if (skip.some((s) => (s instanceof RegExp ? s.test(path) : path.startsWith(s)))) return;
    const body = JSON.stringify({
      path,
      visitor_id: getVisitorId(),
      referrer: document.referrer || "",
    });
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/public/track`;
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
        return;
      }
    } catch {
      // fall through to fetch
    }
    fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  }, [location.pathname, skip, user, loading]);
  return null;
}
